import React from 'react';
import GoogleButton from '../ui/GoogleButton';
import useResolver from '../hooks/useResolver';
import AccountStore, { SocialLoginProvider } from '../store/AccountStore';
import useToast from '../hooks/useToast';

export interface ConnectedGoogleLoginProps {}

const ConnectedGoogleLogin: React.FC<ConnectedGoogleLoginProps> = () => {
  const accountStore = useResolver(AccountStore);
  const toast = useToast();

  return (
    <GoogleButton
      onClick={() =>
        accountStore.socialLogin(SocialLoginProvider.GOOGLE).catch((e) =>
          toast({
            status: 'error',
            title: 'Sign in failed',
            description: e.message,
          }),
        )
      }
    />
  );
};

export default ConnectedGoogleLogin;
